module.exports = __webpack_public_path__ + "img/SKMJ_check3.6b88f5de.png";